export const light = {
  palette: {
    background: ['#ECEAF8', 'transparent', '#ffffff'],
    text: ['#ffffff', '#000000'],
    gray: ['#D7D7E2'],
    border: ['#D7D7E2', '#6366f1'],
  },
  sizes: {
    lineHeight: {
      xSmall: '10px',
      tiny: '19px',
      smaller: '30px',
      small: '45px',
      normal: '50px',
    },
    border: {
      tiny: '5px',
      small: '7px',
      normal: '18px',
    },
    gap: {
      tiny: '5px',
      small: '10px',
      normal: '18px',
      medium: '20px',
      big: '40px',
    },
    borderRadius: {
      normal: '18px',
      tiny: '4px',
      small: '10px',
    },
    button: {
      normal: {
        width: '200px',
        height: '48px',
      },
    },
    inputBox: {
      height: {
        tiny: '40px',
        xsmaller: '47px',
        smaller: '50px',
        small: '58px',
        medium: '60px',
        large: '64px',
        larger: '80px',
      },
    },
    textArea: {
      height: {
        medium: '113px',
        large: '120px',
        larger: '160px',
      },
    },
    font: {
      small: '12px',
      normal: '14px',
      medium: '15px',
      header1: '26px',
      header2: '24px',
    },
    mdFont: {
      small: '12px',
      normal: '14px',
      medium: '15px',
      header1: '26px',
      header2: '24px',
    },
    lgFont: {
      small: '12px',
      normal: '14px',
      medium: '15px',
      header1: '26px',
      header2: '24px',
    },
    xlFont: {
      small: '12px',
      normal: '16px',
      medium: '20px',
      header1: '60px',
      header2: '30px',
    },
    xlrFont: {
      small: '16px',
      normal: '16px',
      medium: '20px',
      header1: '60px',
      header2: '30px',
    },
    xxlFont: {
      small: '16px',
      normal: '20px',
      medium: '20px',
      header1: '60px',
      header2: '30px',
    },
    vxxlFont: {
      small: '16px',
      normal: '20px',
      medium: '20px',
      header1: '60px',
      header2: '30px',
    },
  },
  fonts: {
    primary: 'JetBrains Mono Regular',
    pre: 'Consolas, Liberation Mono, Menlo, Courier, monospace',
  },
};

export const dark = {};

export const themes = { light, dark };
